import React, { useEffect, useState } from 'react'

import { useTranslations } from '@dfb/gatsby-dfb-theme/src/hooks/useTranslations'

import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbInput from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input'
import DfbInputTextarea from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_input_textarea'
import DfbParagraph from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_paragraph'
import DfbSelect from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_select'
import MDefaultform from '../m_defaultForm'
import { extractFields } from '../../../../../../utils/form/extractFields'
import { emailRegex } from '../../../../../../utils/form/emailRegex'

const defaultAssociationWithDistricts = [
  {
    id: 'BadischerFussballverband',
    name: 'Badischer Fußball-Verband',
    items: [
      { id: 'kreis-bruchsal', name: 'Kreis Bruchsal' },
      { id: 'kreis-buchen', name: 'Kreis Buchen' },
      { id: 'kreis-heidelberg', name: 'Kreis Heidelberg' },
      { id: 'kreis-karlsruhe', name: 'Kreis Karlsruhe' },
      { id: 'kreis-mannheim', name: 'Kreis Mannheim' },
      { id: 'kreis-mosbach', name: 'Kreis Mosbach' },
      { id: 'kreis-pforzheim', name: 'Kreis Pforzheim' },
      { id: 'kreis-sinsheim', name: 'Kreis Sinsheim' },
      { id: 'kreis-tauberbischofsheim', name: 'Kreis Tauberbischofsheim' },
    ],
  },
  {
    id: 'BayerischerFussballVerband',
    name: 'Bayerischer Fußball-Verband',
    items: [
      { id: 'kreis-allgau', name: 'Kreis Allgäu' },
      { id: 'kreis-amberg-weiden', name: 'Kreis Amberg/Weiden' },
      { id: 'kreis-aschaffenburg', name: 'Kreis Aschaffenburg' },
      { id: 'kreis-augsburg', name: 'Kreis Augsburg' },
      {
        id: 'kreis-bamberg-bayreuth-kulmb',
        name: 'Kreis Bamberg/Bayreuth/Kulmb.',
      },
      { id: 'kreis-cham-schwandorf', name: 'Kreis Cham/Schwandorf' },
      {
        id: 'kreis-coburg-kronach-lichtenf',
        name: 'Kreis Coburg/Kronach/Lichtenf.',
      },
      { id: 'kreis-donau', name: 'Kreis Donau' },
      { id: 'kreis-donau-isar', name: 'Kreis Donau/Isar' },
      {
        id: 'kreis-erlangen-pegnitzgrund',
        name: 'Kreis Erlangen/Pegnitzgrund',
      },
      {
        id: 'kreis-hof-tischreuth-wunsiedel',
        name: 'Kreis Hof/Tischreuth/Wunsiedel',
      },
      { id: 'kreis-inn-salzach', name: 'Kreis Inn/Salzach' },
      { id: 'kreis-munchen', name: 'Kreis München' },
      { id: 'kreis-neumarkt-jura', name: 'Kreis Neumarkt/Jura' },
      {
        id: 'kreis-nurnberg-frankenhohe',
        name: 'Kreis Nürnberg/Frankenhöhe',
      },
      { id: 'kreis-niederbayern-ost', name: 'Kreis Niederbayern Ost' },
      { id: 'kreis-regensburg', name: 'Kreis Regensburg' },
      { id: 'kreis-rhon', name: 'Kreis Rhön' },
      { id: 'kreis-schweinfurt', name: 'Kreis Schweinfurt' },
      { id: 'kreis-niederbayern-west', name: 'Kreis Niederbayern West' },
      { id: 'kreis-wurzburg', name: 'Kreis Würzburg' },
      { id: 'kreis-zugspitze', name: 'Kreis Zugspitze' },
    ],
  },
  {
    id: 'BerlinerFussballVerband',
    name: 'Berliner Fußball-Verband e. V.',
    items: [{ id: 'kreis-berlin', name: 'Kreis Berlin' }],
  },
  {
    id: 'BremerFussballVerband',
    name: 'Bremer Fußball-Verband',
    items: [
      { id: 'kreis-bremen-nord', name: 'Kreis Bremen-Nord' },
      { id: 'kreis-bremen-stadt', name: 'Kreis Bremen-Stadt' },
      { id: 'kreis-bremerhaven', name: 'Kreis Bremerhaven' },
    ],
  },
  {
    id: 'FussballundLeichtathletikVerbandWestfalen',
    name: 'Fußball- u. Leichtathletik-Verband Westfalen',
    items: [
      { id: 'kreis-ahaus-coesfeld', name: 'KREIS AHAUS-COESFELD' },
      { id: 'kreis-arnsberg', name: 'KREIS ARNSBERG' },
      { id: 'kreis-beckum', name: 'KREIS BECKUM' },
      { id: 'kreis-bielefeld', name: 'KREIS BIELEFELD' },
      { id: 'kreis-bochum', name: 'KREIS BOCHUM' },
      { id: 'kreis-detmold', name: 'KREIS DETMOLD' },
      { id: 'kreis-dortmund', name: 'KREIS DORTMUND' },
      { id: 'kreis-gelsenkirchen', name: 'KREIS GELSENKIRCHEN' },
      { id: 'kreis-gutersloh', name: 'KREIS GÜTERSLOH' },
      { id: 'kreis-hagen', name: 'KREIS HAGEN' },
      { id: 'kreis-herford', name: 'KREIS HERFORD' },
      { id: 'kreis-herne', name: 'KREIS HERNE' },
      { id: 'kreis-hochsauerlandkreis', name: 'KREIS HOCHSAUERLANDKREIS' },
      { id: 'kreis-hoxter', name: 'KREIS HÖXTER' },
      { id: 'kreis-iserlohn', name: 'KREIS ISERLOHN' },
      { id: 'kreis-lemgo', name: 'KREIS LEMGO' },
      { id: 'kreis-lippstadt', name: 'KREIS LIPPSTADT' },
      { id: 'kreis-lubbecke', name: 'KREIS LÜBBECKE' },
      { id: 'kreis-ludenscheid', name: 'KREIS LÜDENSCHEID' },
      { id: 'kreis-minden', name: 'KREIS MINDEN' },
      { id: 'kreis-munster', name: 'KREIS MÜNSTER' },
      { id: 'kreis-olpe', name: 'KREIS OLPE' },
      { id: 'kreis-paderborn', name: 'KREIS PADERBORN' },
      { id: 'kreis-recklinghausen', name: 'KREIS RECKLINGHAUSEN' },
      { id: 'kreis-siegen-wittgenstein', name: 'KREIS SIEGEN-WITTGENSTEIN' },
      { id: 'kreis-soest', name: 'KREIS SOEST' },
      { id: 'kreis-steinfurt', name: 'KREIS STEINFURT' },
      { id: 'kreis-tecklenburg', name: 'KREIS TECKLENBURG' },
      { id: 'kreis-unna-hamm', name: 'KREIS UNNA-HAMM' },
    ],
  },
  {
    id: 'FussballLandesverbandBrandenburg',
    name: 'Fußball-Landesverband Brandenburg',
    items: [
      { id: 'kreis-dahme-flaming', name: 'Kreis Dahme/Fläming' },
      { id: 'kreis-havelland', name: 'Kreis Havelland' },
      { id: 'kreis-niederlausitz', name: 'Kreis Niederlausitz' },
      { id: 'kreis-oberhavel-barnim', name: 'Kreis Oberhavel/Barnim' },
      { id: 'kreis-ostbrandenburg', name: 'Kreis Ostbrandenburg' },
      { id: 'kreis-prignitz-ruppin', name: 'Kreis Prignitz/Ruppin' },
      { id: 'kreis-sudbrandenburg', name: 'Kreis Südbrandenburg' },
      { id: 'kreis-uckermark', name: 'Kreis Uckermark' },
    ],
  },
  {
    id: 'FussballVerbandMittelrhein',
    name: 'Fußball-Verband Mittelrhein',
    items: [
      { id: 'kreis-aachen', name: 'KREIS AACHEN' },
      { id: 'kreis-berg', name: 'KREIS BERG' },
      { id: 'kreis-bonn', name: 'KREIS BONN' },
      { id: 'kreis-duren', name: 'KREIS DÜREN' },
      { id: 'kreis-euskirchen', name: 'KREIS EUSKIRCHEN' },
      { id: 'kreis-heinsberg', name: 'KREIS HEINSBERG' },
      { id: 'kreis-koln', name: 'KREIS KÖLN' },
      { id: 'kreis-rhein-erft', name: 'KREIS RHEIN-ERFT' },
      { id: 'kreis-sieg', name: 'KREIS SIEG' },
    ],
  },
  {
    id: 'FussballverbandNiederrhein',
    name: 'Fußball-Verband Niederrhein',
    items: [
      {
        id: 'kreis-duisburg-mulheim-dinslak',
        name: 'KREIS DUISBURG-MÜLHEIM-DINSLAK',
      },
      { id: 'kreis-dusseldorf', name: 'KREIS DÜSSELDORF' },
      { id: 'kreis-essen', name: 'KREIS ESSEN' },
      { id: 'kreis-grevenbroich-neuss', name: 'KREIS GREVENBROICH-NEUSS' },
      { id: 'kreis-kempen-krefeld', name: 'KREIS KEMPEN-KREFELD' },
      { id: 'kreis-kleve-geldern', name: 'KREIS KLEVE-GELDERN' },
      { id: 'kreis-moers', name: 'KREIS MOERS' },
      {
        id: 'kreis-monchengladbach-viersen',
        name: 'KREIS MÖNCHENGLADBACH-VIERSEN',
      },
      { id: 'kreis-oberhausen-bottrop', name: 'KREIS OBERHAUSEN-BOTTROP' },
      { id: 'kreis-rees-bocholt', name: 'KREIS REES-BOCHOLT' },
      { id: 'kreis-remscheid', name: 'KREIS REMSCHEID' },
      { id: 'kreis-solingen', name: 'KREIS SOLINGEN' },
      {
        id: 'kreis-wuppertal-niederberg',
        name: 'KREIS WUPPERTAL-NIEDERBERG',
      },
    ],
  },
  {
    id: 'FussballverbandRheinland',
    name: 'Fußballverband Rheinland',
    items: [
      { id: 'kreis-eifel', name: 'Kreis Eifel' },
      { id: 'kreis-hunsruck-mosel', name: 'Kreis Hunsrück/Mosel' },
      { id: 'kreis-koblenz', name: 'Kreis Koblenz' },
      { id: 'kreis-mosel', name: 'Kreis Mosel' },
      { id: 'kreis-rhein-ahr', name: 'Kreis Rhein/Ahr' },
      { id: 'kreis-rhein-lahn', name: 'Kreis Rhein/Lahn' },
      { id: 'kreis-trier-saarburg', name: 'Kreis Trier/Saarburg' },
      { id: 'kreis-westerwald-sieg', name: 'Kreis Westerwald/Sieg' },
      { id: 'kreis-westerwald-wied', name: 'Kreis Westerwald/Wied' },
    ],
  },
  {
    id: 'FussballverbandSachsenAnhalt',
    name: 'Fußball-Verband Sachsen-Anhalt',
    items: [
      { id: 'kreis-altmark-ost', name: 'Kreis Altmark Ost' },
      { id: 'kreis-altmark-west', name: 'Kreis Altmark West' },
      { id: 'kreis-anhalt', name: 'Kreis Anhalt' },
      { id: 'kreis-anhalt-bitterfeld', name: 'Kreis Anhalt-Bitterfeld' },
      { id: 'kreis-borde', name: 'Kreis Börde' },
      { id: 'kreis-burgenland', name: 'Kreis Burgenland' },
      { id: 'kreis-harz', name: 'Kreis Harz' },
      { id: 'kreis-jerichower-land', name: 'Kreis Jerichower Land' },
      { id: 'kreis-mansfeld-sudharz', name: 'Kreis Mansfeld-Südharz' },
      { id: 'kreis-saalekreis', name: 'Kreis Saalekreis' },
      { id: 'kreis-salzland', name: 'Kreis Salzland' },
      { id: 'kreis-sfv-halle', name: 'Kreis SFV Halle' },
      { id: 'kreis-sfv-magdeburg', name: 'Kreis SFV Magdeburg' },
      { id: 'kreis-wittenberg', name: 'Kreis Wittenberg' },
    ],
  },
  {
    id: 'HamburgerFussballVerband',
    name: 'Hamburger Fußball-Verband',
    items: [{ id: 'kreisebene-hamburg', name: 'Kreisebene Hamburg' }],
  },
  {
    id: 'HessischerFussballVerband',
    name: 'Hessischer Fußball-Verband',
    items: [
      { id: 'kreis-alsfeld', name: 'Kreis Alsfeld' },
      { id: 'kreis-bergstrasse', name: 'Kreis Bergstraße' },
      { id: 'kreis-biedenkopf', name: 'Kreis Biedenkopf' },
      { id: 'kreis-budingen', name: 'Kreis Büdingen' },
      { id: 'kreis-darmstadt', name: 'Kreis Darmstadt' },
      { id: 'kreis-dieburg', name: 'Kreis Dieburg' },
      { id: 'kreis-dillenburg', name: 'Kreis Dillenburg' },
      { id: 'kreis-frankenberg', name: 'Kreis Frankenberg' },
      { id: 'kreis-frankfurt', name: 'Kreis Frankfurt' },
      { id: 'kreis-friedberg', name: 'Kreis Friedberg' },
      { id: 'kreis-fulda', name: 'Kreis Fulda' },
      { id: 'kreis-gelnhausen', name: 'Kreis Gelnhausen' },
      { id: 'kreis-giessen', name: 'Kreis Gießen' },
      { id: 'kreis-gross-gerau', name: 'Kreis Groß-Gerau' },
      { id: 'kreis-hanau', name: 'Kreis Hanau' },
      { id: 'kreis-hersfeld-rotenburg', name: 'Kreis Hersfeld-Rotenburg' },
      { id: 'kreis-hochtaunus', name: 'Kreis Hochtaunus' },
      {
        id: 'kreis-hofgeismar-wolfhagen',
        name: 'Kreis Hofgeismar-Wolfhagen',
      },
      { id: 'kreis-kassel', name: 'Kreis Kassel' },
      { id: 'kreis-lauterbach-hunfeld', name: 'Kreis Lauterbach-Hünfeld' },
      { id: 'kreis-limburg-weilburg', name: 'Kreis Limburg-Weilburg' },
      { id: 'kreis-maintaunus', name: 'Kreis Maintaunus' },
      { id: 'kreis-marburg', name: 'Kreis Marburg' },
      { id: 'kreis-odenwald', name: 'Kreis Odenwald' },
      { id: 'kreis-offenbach', name: 'Kreis Offenbach' },
      { id: 'kreis-rheingau-taunus', name: 'Kreis Rheingau-Taunus' },
      { id: 'kreis-schluchtern', name: 'Kreis Schlüchtern' },
      { id: 'kreis-schwalm-eder', name: 'Kreis Schwalm-Eder' },
      { id: 'kreis-waldeck', name: 'Kreis Waldeck' },
      { id: 'kreis-werra-meissner', name: 'Kreis Werra/Meißner' },
      { id: 'kreis-wetzlar', name: 'Kreis Wetzlar' },
      { id: 'kreis-wiesbaden', name: 'Kreis Wiesbaden' },
    ],
  },
  {
    id: 'LandesfussballverbandMecklenburgVorpommern',
    name: 'Landesfußballverband Mecklenburg-Vorpommern',
    items: [
      {
        id: 'kreis-mecklenburg-seenplatte',
        name: 'Kreis Mecklenburg. Seenplatte',
      },
      {
        id: 'kreis-nordvorpommern-rugen',
        name: 'Kreis Nordvorpommern-Rügen',
      },
      {
        id: 'kreis-schwerin-nordwestmeckl',
        name: 'Kreis Schwerin-Nordwestmeckl.',
      },
      {
        id: 'kreis-vorpommern-greifswald',
        name: 'Kreis Vorpommern-Greifswald',
      },
      { id: 'kreis-warnow', name: 'Kreis Warnow' },
      { id: 'kreis-westmecklenburg', name: 'Kreis Westmecklenburg' },
    ],
  },
  {
    id: 'NiedersaechsischerFussballverband',
    name: 'Niedersächsischer Fußballverband',
    items: [
      { id: 'kreis-bentheim', name: 'Kreis Bentheim' },
      { id: 'kreis-braunschweig', name: 'Kreis Braunschweig' },
      { id: 'kreis-celle', name: 'Kreis Celle' },
      { id: 'kreis-cloppenburg', name: 'Kreis Cloppenburg' },
      { id: 'kreis-cuxhaven', name: 'Kreis Cuxhaven' },
      { id: 'kreis-diepholz', name: 'Kreis Diepholz' },
      { id: 'kreis-emsland', name: 'Kreis Emsland' },
      { id: 'kreis-gifhorn', name: 'Kreis Gifhorn' },
      { id: 'kreis-gottingen-osterode', name: 'Kreis Göttingen-Osterode' },
      { id: 'kreis-hameln-pyrmont', name: 'Kreis Hameln-Pyrmont' },
      { id: 'kreis-harburg', name: 'Kreis Harburg' },
      { id: 'kreis-heide-wendland', name: 'Kreis Heide-Wendland' },
      { id: 'kreis-heidekreis', name: 'Kreis Heidekreis' },
      { id: 'kreis-helmstedt', name: 'Kreis Helmstedt' },
      { id: 'kreis-hildesheim', name: 'Kreis Hildesheim' },
      { id: 'kreis-holzminden', name: 'Kreis Holzminden' },
      { id: 'kreis-jade-weser-hunte', name: 'Kreis Jade-Weser-Hunte' },
      { id: 'kreis-nienburg', name: 'Kreis Nienburg' },
      { id: 'kreis-nordharz', name: 'Kreis Nordharz' },
      { id: 'kreis-northeim-einbeck', name: 'Kreis Northeim-Einbeck' },
      {
        id: 'kreis-oldenburg-l-delmenhorst',
        name: 'Kreis Oldenburg-L./Delmenhorst',
      },
      { id: 'kreis-osnabruck', name: 'Kreis Osnabrück' },
      { id: 'kreis-osterholz', name: 'Kreis Osterholz' },
      { id: 'kreis-ostfriesland', name: 'Kreis Ostfriesland' },
      { id: 'kreis-peine', name: 'Kreis Peine' },
      { id: 'kreis-region-hannover', name: 'Kreis Region Hannover' },
      { id: 'kreis-rotenburg', name: 'Kreis Rotenburg' },
      { id: 'kreis-schaumburg', name: 'Kreis Schaumburg' },
      { id: 'kreis-stade', name: 'Kreis Stade' },
      { id: 'kreis-vechta', name: 'Kreis Vechta' },
      { id: 'kreis-verden', name: 'Kreis Verden' },
      { id: 'kreis-wolfsburg', name: 'Kreis Wolfsburg' },
    ],
  },
  {
    id: 'SaarlaendischerFussballverband',
    name: 'Saarländischer Fußball-Verband',
    items: [
      { id: 'kreis-nordsaar', name: 'Kreis Nordsaar' },
      { id: 'kreis-ostsaar', name: 'Kreis Ostsaar' },
      { id: 'kreis-sudsaar', name: 'Kreis Südsaar' },
      { id: 'kreis-westsaar', name: 'Kreis Westsaar' },
    ],
  },
  {
    id: 'SaechsischerFussballVerband',
    name: 'Sächsischer Fußball-Verband',
    items: [
      { id: 'kreis-chemnitz', name: 'Kreis Chemnitz' },
      { id: 'kreis-dresden', name: 'Kreis Dresden' },
      { id: 'kreis-erzgebirge', name: 'Kreis Erzgebirge' },
      { id: 'kreis-leipzig', name: 'Kreis Leipzig' },
      { id: 'kreis-meissen', name: 'Kreis Meißen' },
      { id: 'kreis-mittelsachsen', name: 'Kreis Mittelsachsen' },
      {
        id: 'kreis-muldental-leipziger-land',
        name: 'Kreis Muldental/Leipziger Land',
      },
      { id: 'kreis-nordsachsen', name: 'Kreis Nordsachsen' },
      { id: 'kreis-oberlausitz', name: 'Kreis Oberlausitz' },
      {
        id: 'kreis-sachs-schweiz-osterzgeb',
        name: 'Kreis Sächs.Schweiz/Osterzgeb.',
      },
      { id: 'kreis-vogtland', name: 'Kreis Vogtland' },
      { id: 'kreis-westlausitz', name: 'Kreis Westlausitz' },
      { id: 'kreis-zwickau', name: 'Kreis Zwickau' },
    ],
  },
  {
    id: 'SchleswigHolsteinischerFussballverband',
    name: 'Schleswig-Holsteinischer Fußballverband',
    items: [
      { id: 'kreis-herzogtum-lauenburg', name: 'Kreis Herzogtum Lauenburg' },
      { id: 'kreis-holstein', name: 'Kreis Holstein' },
      { id: 'kreis-kiel', name: 'Kreis Kiel' },
      { id: 'kreis-lubeck', name: 'Kreis Lübeck' },
      { id: 'kreis-nordfriesland', name: 'Kreis Nordfriesland' },
      { id: 'kreis-ostholstein', name: 'Kreis Ostholstein' },
      {
        id: 'kreis-rendsburg-eckernforde',
        name: 'Kreis Rendsburg-Eckernförde',
      },
      { id: 'kreis-schleswig-flensburg', name: 'Kreis Schleswig-Flensburg' },
      { id: 'kreis-segeberg', name: 'Kreis Segeberg' },
      { id: 'kreis-stormarn', name: 'Kreis Stormarn' },
      { id: 'kreis-westkuste', name: 'Kreis Westküste' },
    ],
  },
  {
    id: 'SuedbadischerFussballverband',
    name: 'Südbadischer Fußball-Verband',
    items: [
      { id: 'baden-baden', name: 'Baden-Baden' },
      { id: 'bodensee', name: 'Bodensee' },
      { id: 'freiburg', name: 'Freiburg' },
      { id: 'hochrhein', name: 'Hochrhein' },
      { id: 'offenburg', name: 'Offenburg' },
      { id: 'schwarzwald', name: 'Schwarzwald' },
    ],
  },
  {
    id: 'SuedwestdeutscherFussballverband',
    name: 'Südwestdeutscher Fußball-Verband',
    items: [
      { id: 'kreis-alzey-worms', name: 'Kreis Alzey-Worms' },
      { id: 'kreis-bad-kreuznach', name: 'Kreis Bad Kreuznach' },
      { id: 'kreis-birkenfeld', name: 'Kreis Birkenfeld' },
      {
        id: 'kreis-kaiserslaut-donnersberg',
        name: 'Kreis Kaiserslaut.-Donnersberg',
      },
      {
        id: 'kreis-kusel-kaiserslautern',
        name: 'Kreis Kusel-Kaiserslautern',
      },
      { id: 'kreis-mainz-bingen', name: 'Kreis Mainz-Bingen' },
      {
        id: 'kreis-pirmasens-zweibrucken',
        name: 'Kreis Pirmasens/Zweibrücken',
      },
      { id: 'kreis-rhein-mittelhaardt', name: 'Kreis Rhein-Mittelhaardt' },
      { id: 'kreis-rhein-pfalz', name: 'Kreis Rhein-Pfalz' },
      { id: 'kreis-sudpfalz', name: 'Kreis Südpfalz' },
    ],
  },
  {
    id: 'ThueringerFussballVerband',
    name: 'Thüringer Fußball-Verband',
    items: [
      {
        id: 'kreis-eichsf-unstrut-hainich',
        name: 'Kreis Eichsf.-Unstrut-Hainich',
      },
      { id: 'kreis-erfurt-sommerda', name: 'Kreis Erfurt-Sömmerda' },
      { id: 'kreis-jena-saale-orla', name: 'Kreis Jena-Saale-Orla' },
      { id: 'kreis-mittelthuringen', name: 'Kreis Mittelthüringen' },
      { id: 'kreis-nordthuringen', name: 'Kreis Nordthüringen' },
      { id: 'kreis-ostthuringen', name: 'Kreis Ostthüringen' },
      { id: 'kreis-rhon-rennsteig', name: 'Kreis Rhön-Rennsteig' },
      { id: 'kreis-sudthuringen', name: 'Kreis Südthüringen' },
      { id: 'kreis-westthuringen', name: 'Kreis Westthüringen' },
    ],
  },
  {
    id: 'WuerttembergischerFussballverband',
    name: 'Württembergischer Fußball-Verband',
    items: [
      { id: 'bezirk-alb', name: 'Bezirk Alb' },
      { id: 'bezirk-bodensee', name: 'Bezirk Bodensee' },
      { id: 'bezirk-donau-iller', name: 'Bezirk Donau/Iller' },
      { id: 'bezirk-enz-murr', name: 'Bezirk Enz/Murr' },
      { id: 'bezirk-franken', name: 'Bezirk Franken' },
      { id: 'bezirk-neckar-fils', name: 'Bezirk Neckar/Fils' },
      {
        id: 'bezirk-nordschwarzwald',
        name: 'Bezirk Nordschwarzwald ',
      },
      { id: 'bezirk-oberschwaben', name: 'Bezirk Oberschwaben' },
      { id: 'bezirk-ostwurttemberg', name: 'Bezirk Ostwürttemberg' },
      { id: 'bezirk-rems-murr-hall', name: 'Bezirk Rems/Murr/Hall' },
      { id: 'bezirk-schwarzwald-zollern', name: 'Bezirk Schwarzwald/Zollern' },
      { id: 'bezirk-stuttgart-boblingen', name: 'Bezirk Stuttgart/Böblingen' },
    ],
  },
]

const MVolunteerAward = ({ data }) => {
  const t = useTranslations()
  const formType = data.form_definition[0].identifier
  const fields = extractFields(data?.form_definition?.[0]?.form_field)
  const [associationWithDistricts, setAssociationWithDistricts] = useState(defaultAssociationWithDistricts)
  const [districtOptions, setDistrictOptions] = useState([])
  const [currentIdentifier, setCurrentIdentifier] = useState('')
  const [email, setEmail] = useState('')
  const identifierObject = []

  useEffect(() => {
    setAssociationWithDistricts(
      defaultAssociationWithDistricts
        .map((association) => {
          const recipient = data.form_recipient.find((recipient) => recipient.identifier === association.id)
          if (recipient) {
            return {
              ...association,
              name: recipient.name,
            }
          }
          return null
        })
        .filter((association) => association !== null)
    )
  }, [data.form_recipient])

  data.form_recipient.forEach((recipient) => {
    identifierObject.push({
      name: recipient.name,
      identifier: recipient.identifier,
    })
  })

  const selectSalutation = {
    label: t('form.salutation.label'),
    identifier: 'salutation',
    values: [
      { id: '0', name: t('form.salutation.mr') },
      { id: '1', name: t('form.salutation.mrs') },
    ],
  }

  const errorMessageSelect = t('form.errorMessage.select')
  const applicantInfo = t('form.volunteerAward.applicantInfo')
  const applicantInfo2 = t('form.volunteerAward.applicantInfo2')
  const hint = t('form.volunteerAward.hint')

  const handleAssociationChange = (event) => {
    const currentAssociation = associationWithDistricts.find((association) => association.name === event.target.value)
    setDistrictOptions(currentAssociation.items || [])

    identifierObject.forEach((item) => {
      if (item.name === event.target.value) {
        setCurrentIdentifier(item.identifier)
      }
    })
  }

  return (
    <MDefaultform
      buttonLabel="Absenden"
      postUrl={process.env.FORM_API_URL}
      disableCaptcha={data.form_definition[0].captcha === 0}
      identifier={currentIdentifier}
      DOImail={email}
      formType={formType}
      shouldPersist={data.form_definition[0].save_in_db}
    >
      {({ register, errors }) => (
        <>
          {data.headline && <DfbHeadline headline={data.headline} headline_level="h3" add_class="m-Formblock-headline" />}
          {data.text && <DfbParagraph add_class="m-Formblock-text" text={data.text} />}
          <div className="m-Formblock-spacer"></div>
          {(fields.nationalassociation || fields.district) && (
            <div className="m-Formblock-input-half">
              {fields.nationalassociation && (
                <div className="m-Formblock-input">
                  <DfbSelect
                    {...register('nationalassociation', {
                      required: errorMessageSelect,
                    })}
                    label={fields.nationalassociation.label}
                    options={associationWithDistricts.map(({ id, name }) => ({
                      id,
                      name,
                    }))}
                    placeholder={t('form.placeholder.select')}
                    errorMessage={errors?.[fields.nationalassociation.identifier]?.message}
                    error={errors[fields.nationalassociation.identifier]}
                    onChange={handleAssociationChange}
                  />
                </div>
              )}
              {fields.district && (
                <div className="m-Formblock-input">
                  <DfbSelect
                    {...register(fields.district.identifier, {
                      required: errorMessageSelect,
                    })}
                    label={fields.district.label}
                    options={districtOptions}
                    placeholder={t('form.placeholder.select')}
                    errorMessage={errors?.[fields.district.identifier]?.message}
                    error={errors[fields.district.identifier]}
                  />
                </div>
              )}
            </div>
          )}
          <div className="m-Formblock-spacer"></div>
          <DfbHeadline headline={t('form.volunteerAward.proposerHeadline')} headline_level="h4" add_class="m-Formblock-headline" />
          {(fields.proposerfirstname || fields.proposerlastname) && (
            <div className="m-Formblock-input-half">
              {[fields.proposerfirstname, fields.proposerlastname].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                  />
                </div>
              ))}
            </div>
          )}
          {(fields.proposerclub || fields.proposerposition) && (
            <div className="m-Formblock-input-half">
              {[fields.proposerclub, fields.proposerposition].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                  />
                </div>
              ))}
            </div>
          )}
          {(fields.proposerphone || fields.proposeremail) && (
            <div className="m-Formblock-input-half">
              {[fields.proposerphone, fields.proposeremail].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                      pattern:
                        formItem.identifier === fields.proposeremail?.identifier
                          ? {
                              value: emailRegex,
                              message: t('form.errorMessage.emailPattern'),
                            }
                          : undefined,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                  />
                </div>
              ))}
            </div>
          )}
          {fields.proposerbeginvoluntarywork && (
            <div className="m-Formblock-input-half">
              <div className="m-Formblock-input">
                <DfbInput
                  type="date"
                  {...register(fields.proposerbeginvoluntarywork.identifier, {
                    required: fields.proposerbeginvoluntarywork.required === 1 ? t('form.errorMessage.input') : false,
                  })}
                  error={errors[fields.proposerbeginvoluntarywork.identifier]}
                  errorMessage={errors?.[fields.proposerbeginvoluntarywork.identifier]?.message}
                  label={`${fields.proposerbeginvoluntarywork.label}${fields.proposerbeginvoluntarywork.required === 1 ? '*' : ''}`}
                />
              </div>
              <div className="m-Formblock-input"></div>
            </div>
          )}
          <div className="m-Formblock-spacer"></div>
          <DfbHeadline headline={t('form.volunteerAward.applicantHeadline')} headline_level="h4" add_class="m-Formblock-headline" />
          {applicantInfo && <DfbParagraph add_class="m-Formblock-text" text={applicantInfo} />}
          {selectSalutation && (
            <div className="m-Formblock-input-half">
              <div className="m-Formblock-input">
                <DfbSelect
                  {...register(selectSalutation.identifier, {
                    required: errorMessageSelect,
                  })}
                  label={selectSalutation.label}
                  options={selectSalutation.values}
                  placeholder={t('form.placeholder.select')}
                  errorMessage={errors?.[selectSalutation.identifier]?.message}
                  error={errors[selectSalutation.identifier]}
                />
              </div>
              <div className="m-Formblock-input"></div>
            </div>
          )}
          {(fields.applicantfirstname || fields.applicantlastname) && (
            <div className="m-Formblock-input-half">
              {[fields.applicantfirstname, fields.applicantlastname].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                  />
                </div>
              ))}
            </div>
          )}
          {(fields.applicantclub || fields.applicantposition) && (
            <div className="m-Formblock-input-half">
              {[fields.applicantclub, fields.applicantposition].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                  />
                </div>
              ))}
            </div>
          )}
          <div className="m-Formblock-spacer"></div>
          {(fields.applicantstreet || fields.applicanthousenumber) && (
            <div className="m-Formblock-input-half">
              {[fields.applicantstreet, fields.applicanthousenumber].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                  />
                </div>
              ))}
            </div>
          )}
          {(fields.applicantpostcode || fields.applicantlocation) && (
            <div className="m-Formblock-input-half">
              {[fields.applicantpostcode, fields.applicantlocation].filter(Boolean).map((formItem, index) => (
                <div className="m-Formblock-input" key={index}>
                  <DfbInput
                    {...register(formItem.identifier, {
                      required: formItem.required ? t('form.errorMessage.input') : false,
                      ...(formItem.identifier === 'applicantpostcode' && {
                        pattern: {
                          value: /^\d+$/,
                          message: t('form.errorMessage.postcodePattern'),
                        },
                      }),
                    })}
                    error={errors[formItem.identifier]}
                    errorMessage={errors?.[formItem.identifier]?.message}
                    label={`${formItem.label}${formItem.required === 1 ? '*' : ''}`}
                  />
                </div>
              ))}
            </div>
          )}
          {fields.applicantemail && (
            <div className="m-Formblock-input-half">
              <div className="m-Formblock-input">
                <DfbInput
                  {...register(fields.applicantemail.identifier, {
                    required: fields.applicantemail.required ? t('form.errorMessage.input') : false,
                    pattern: {
                      value: emailRegex,
                      message: t('form.errorMessage.emailPattern'),
                    },
                    onChange: (e) => {
                      setEmail(e.target.value)
                    },
                  })}
                  error={errors[fields.applicantemail.identifier]}
                  errorMessage={errors?.[fields.applicantemail.identifier]?.message}
                  label={`${fields.applicantemail.label}${fields.applicantemail.required === 1 ? '*' : ''}`}
                />
              </div>
            </div>
          )}
          <div className="m-Formblock-spacer"></div>
          {fields.applicantreasonforaward && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.applicantreasonforaward.identifier, {
                  required: fields.applicantreasonforaward.required === 1 ? t('form.errorMessage.input') : false,
                })}
                label={`${fields.applicantreasonforaward.label}${fields.applicantreasonforaward.required === 1 ? '*' : ''}`}
                error={errors[fields.applicantreasonforaward.identifier]}
                errorMessage={errors?.[fields.applicantreasonforaward.identifier]?.message}
              />
            </div>
          )}
          {fields.applicantfurtherreason && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.applicantfurtherreason.identifier, {
                  required: fields.applicantfurtherreason.required === 1 ? t('form.errorMessage.input') : false,
                })}
                label={`${fields.applicantfurtherreason.label}${fields.applicantfurtherreason.required === 1 ? '*' : ''}`}
                error={errors[fields.applicantfurtherreason.identifier]}
                errorMessage={errors?.[fields.applicantfurtherreason.identifier]?.message}
              />
            </div>
          )}
          {fields.applicantcareerinclub && (
            <div className="m-Formblock-input">
              <DfbInputTextarea
                {...register(fields.applicantcareerinclub.identifier, {
                  required: fields.applicantcareerinclub.required === 1 ? t('form.errorMessage.input') : false,
                })}
                label={`${fields.applicantcareerinclub.label}${fields.applicantcareerinclub.required === 1 ? '*' : ''}`}
                error={errors[fields.applicantcareerinclub.identifier]}
                errorMessage={errors?.[fields.applicantcareerinclub.identifier]?.message}
              />
            </div>
          )}
          {applicantInfo2 && <DfbParagraph add_class="m-Formblock-text" text={applicantInfo2} />}
          {fields.hint && <DfbParagraph add_class="m-Formblock-text" text={hint} />}
        </>
      )}
    </MDefaultform>
  )
}

export default MVolunteerAward
